module.exports = __webpack_public_path__ + "static/media/iconoCompartir.99a264fc.svg";